import founder from "@/assets/optimized-images/founder.png";

const Instructor = () => {
  return (
    <div className="flex gap-5 items-center justify-center flex-col sm:flex-row font-[Roboto]">
      <div className="rounded-full overflow-hidden">
        <img src={founder} alt="" width={100} className="sm:w-[10rem] " />
      </div>
      <div className="space-y-3  text-center sm:text-start">
        <p className="text-3xl sm:text-4xl">Prof Yusuf</p>
        <p className="text-sm sm:text-lg leading-6">
          <i>
            I'll serve You to get your Business Names, Companies, Ngo, Religion
            Centers registered with CAC in few days. Send a Whatsapp DM |
            07015237423
          </i>
        </p>
      </div>
    </div>
  );
};

export default Instructor;
